import ObjectIndexer from '../../infrastructure/types/ObjectIndexer';
import SelectOption from '../../infrastructure/types/SelectOption';

const createUserOptions = (users: ObjectIndexer<string>): SelectOption[] => {

    return Object.keys(users).map(key => { return { value: key, text: users[key] }; })
};

export { createUserOptions };